import { DarkModeToggle } from "../components/toggleButtons";
import { projectsData } from "../projectData";

export const ProjectPage = ({ darkMode, setDarkMode, title }) => {
  return (
    <div className="min-h-screen w-full px-4 py-6 md:py-10">
      <div
        className={`max-w-7xl mx-auto p-4 md:p-6 rounded-lg shadow-lg ${
          darkMode ? "bg-[#181a1b] text-white" : "bg-white text-[#181a1b]"
        }`}
      >
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold">
            {title}
          </h1>
          <DarkModeToggle darkMode={darkMode} setDarkMode={setDarkMode} />
        </div>

        <section className="mt-8 space-y-6">
          <div className="space-y-4">
            <h2 className="text-xl md:text-2xl font-semibold">
              Project Overview
            </h2>
            <p className="text-sm md:text-base lg:text-lg">
              {projectsData[title]["Project Overview"]}
            </p>
          </div>

          <div className="space-y-4">
            <h2 className="text-xl md:text-2xl font-semibold">
              Purpose of the Project
            </h2>
            <p className="text-sm md:text-base lg:text-lg">
              {projectsData[title]["Purpose of the Project"]}
            </p>
          </div>
        </section>

        <div
          className={`mt-6 p-4 rounded-md space-y-4 md:space-y-0 md:flex md:justify-between ${
            darkMode ? "bg-gray-800" : "bg-gray-100"
          }`}
        >
          <div className="space-y-2">
            <h3 className="font-bold">Tech Stack</h3>
            <div className="flex flex-col gap-2">
              {projectsData[title]["TechStack"].map((tech, index) => (
                <span
                  key={index}
                  className="text-sm max-w-[550px] bg-opacity-20 bg-gray-500 px-2 py-1 rounded"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
          <div className="space-y-2">
            <h3 className="font-bold">GitHub</h3>
            <a
              href={projectsData[title]["github"]}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm hover:opacity-70 transition-opacity"
            >
              Repository →
            </a>
          </div>
        </div>

        <div className="mt-8">
          <img
            className="w-full  rounded-lg shadow-lg object-contain object-center max-h-[600px]"
            src={projectsData[title]["Final Render"]}
            alt={`${title} - Final Render`}
          />
        </div>

        <section className="mt-8">
          <h2 className="text-xl md:text-2xl font-semibold mb-6">
            Challenges & Problems Solved
          </h2>

          <div className="space-y-6">
            {projectsData[title]["Challenges & Problems Solved"].map(
              (challenge, index) => (
                <div
                  key={index}
                  className={`p-4 rounded-lg shadow-md ${
                    darkMode ? "bg-gray-800" : "bg-gray-100"
                  }`}
                >
                  <h3 className="text-lg md:text-xl font-bold">
                    {index + 1}. {challenge.problemTitle}
                  </h3>

                  <div className="mt-4 space-y-4">
                    <div>
                      <span className="font-semibold text-base md:text-lg">
                        Problem Description:
                      </span>
                      <p className="mt-2 text-sm md:text-base">
                        {challenge.Problem}
                      </p>
                    </div>

                    {challenge["Issues Faced"].length > 0 && (
                      <div>
                        <h4 className="font-semibold text-red-400 text-base md:text-lg">
                          Issues Faced:
                        </h4>
                        <ul className="mt-2 space-y-2 list-disc list-inside text-sm md:text-base">
                          {challenge["Issues Faced"].map((issue, idx) => (
                            <li key={idx}>{issue}</li>
                          ))}
                        </ul>
                      </div>
                    )}

                    <div className="flex flex-col lg:flex-row gap-6">
                      <div className="flex-1">
                        <span className="font-semibold text-green-400 text-base md:text-lg">
                          Solution:
                        </span>
                        <p className="mt-2 text-sm md:text-base">
                          {challenge.Solution}
                        </p>
                      </div>

                      {challenge.Image && (
                        <div className="lg:w-1/3">
                          <img
                            className="w-full rounded-md shadow-md object-cover"
                            src={challenge.Image}
                            alt={challenge.problemTitle}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </section>

        <section className="mt-8">
          <h2 className="text-xl md:text-2xl font-semibold">Final Thoughts</h2>
          <p className="mt-4 text-sm md:text-base lg:text-lg">
            {projectsData[title]["Final Thoughts"]}
          </p>
        </section>
      </div>
    </div>
  );
};

export default ProjectPage;
